module.exports = new __parcel__URL__("testimonial-dominic-hamdy-mobile.795bc261.webp").toString();